export interface WorkPath {
  key: string;
  kind: 'list' | 'record';
  family: 'partners' | 'products' | 'documents' | 'purchases';
  labelKey: string;
  listPath: string;
}
export function workPath(pathname: string, search = '', locationKey = ''): WorkPath | null {
  const partnerLists: Record<string, string> = {
    '/partners': 'nav.partnerAll',
    '/partners/customers': 'nav.partnerCustomers',
    '/partners/prospects': 'nav.partnerProspects',
    '/partners/suppliers': 'nav.partnerSuppliers',
  };
  const listLabel = partnerLists[pathname];
  if (listLabel)
    return {
      key: pathname,
      kind: 'list',
      family: 'partners',
      labelKey: listLabel,
      listPath: pathname,
    };
  if (pathname === '/products')
    return {
      key: pathname,
      kind: 'list',
      family: 'products',
      labelKey: 'products.title',
      listPath: pathname,
    };
  if (
    pathname === '/documents' ||
    /^\/sales\/(all|quotes|orders|delivery-notes|invoices|credit-notes)$/.test(pathname)
  )
    return {
      key: pathname,
      kind: 'list',
      family: 'documents',
      labelKey:
        pathname === '/sales/orders'
          ? 'nav.salesOrders'
          : pathname === '/sales/quotes'
            ? 'nav.quotes'
            : pathname === '/sales/invoices'
              ? 'nav.invoices'
              : pathname === '/sales/delivery-notes'
                ? 'nav.deliveryNotes'
                : pathname === '/sales/credit-notes'
                  ? 'nav.creditNotes'
                  : 'documents.title',
      listPath: pathname,
    };
  if (pathname === '/procurement/orders')
    return {
      key: pathname,
      kind: 'list',
      family: 'purchases',
      labelKey: 'nav.purchaseOrders',
      listPath: pathname,
    };
  const match = /^\/(partners|products|documents|procurement\/orders)\/([^/]+)(?:\/edit)?$/.exec(
    pathname,
  );
  if (!match || match[2] === 'map' || match[2] === 'archive') return null;
  const family =
    match[1] === 'partners'
      ? 'partners'
      : match[1] === 'products'
        ? 'products'
        : match[1] === 'documents'
          ? 'documents'
          : 'purchases';
  const listPath =
    family === 'partners'
      ? '/partners/customers'
      : family === 'products'
        ? '/products'
        : family === 'documents'
          ? '/documents'
          : '/procurement/orders';
  return {
    key: `/${match[1]}/${match[2]}${match[2] === 'new' ? `:${new URLSearchParams(search).get('draft') ?? locationKey}` : ''}`,
    kind: 'record',
    family,
    labelKey:
      match[2] === 'new'
        ? family === 'products'
          ? 'products.createTitle'
          : family === 'partners'
            ? 'partners.createTitle'
            : 'workTabs.new.document'
        : 'workTabs.record',
    listPath,
  };
}
